import { STRIPE_PURCHASE_INFO } from '@24i/nxg-core-utils/src/constants';
import { Storage } from '@24i/nxg-sdk-quantum';

export const setStripeProductDataToStorage = (productId: string, referrerRoute?: string | null) => {
    const ignoredRouteList = ['/payment-method', '/payment-result'];
    let route = referrerRoute;
    if (referrerRoute && ignoredRouteList.some((v) => referrerRoute.includes(v))) {
        route = null;
    }
    return Storage.setItem(
        STRIPE_PURCHASE_INFO,
        JSON.stringify({
            productId,
            referrerRoute: route,
        })
    );
};

export const getStripeProductDataFromStorage = async () => {
    try {
        return JSON.parse(await Storage.getItem(STRIPE_PURCHASE_INFO));
    } catch (e) {
        return null;
    }
};

export const removeStripeProductDataFromStorage = () => Storage.removeItem(STRIPE_PURCHASE_INFO);
